module.exports = __webpack_public_path__ + "media/ride.5d93de89.mp3";